import { createGlobalState } from '@vueuse/core';
import type { Ref } from 'vue';
import { ref } from 'vue';
import type { PdfPreviewBlockedReason } from '@/types/PdfPreviewBlockedReason';

export const useAiReportState = createGlobalState(
  (): {
    componentIdToEdit: Ref<string | undefined>;
    shouldShowChatBox: Ref<boolean>;
    shouldShowPdfPreview: Ref<boolean>;
    isPdfPreviewLoading: Ref<boolean>;
    isPdfDownloading: Ref<boolean>;
    pdfPreviewBlockedReason: Ref<PdfPreviewBlockedReason | null>;
  } => {
    const componentIdToEdit = ref<string>();
    const shouldShowChatBox = ref(false);

    const shouldShowPdfPreview = ref(false);
    const isPdfPreviewLoading = ref(false);
    const isPdfDownloading = ref(false);
    const pdfPreviewBlockedReason = ref<PdfPreviewBlockedReason | null>(null);

    return {
      componentIdToEdit,
      shouldShowChatBox,
      shouldShowPdfPreview,
      isPdfPreviewLoading,
      isPdfDownloading,
      pdfPreviewBlockedReason,
    };
  },
);
